import { html } from 'htm/preact'
import { useAppState } from '../state.js'
import { logout } from '../api.js'

export default function Topbar({ title, showNav }) {
  const [state, dispatch] = useAppState()

  function toggleTheme() {
    const next = state.theme === 'dark' ? 'light' : state.theme === 'light' ? 'system' : 'dark'
    dispatch({ type: 'SET_THEME', payload: next })
  }

  function themeIcon() {
    if (state.theme === 'dark') return html`<span aria-hidden="true">☾</span>`
    if (state.theme === 'light') return html`<span aria-hidden="true">☀</span>`
    return html`<span aria-hidden="true">◐</span>`
  }

  return html`
    <header class="topbar">
      <div class="topbar__titles">
        <span class="topbar__brand">Menu Cost</span>
        <span class="topbar__tag">${title}</span>
      </div>
      <nav class="topbar__nav" style=${showNav ? '' : 'visibility:hidden'}>
        <a href="#/" data-route="home" class="${location.hash === '#/' || location.hash === '' ? 'is-active' : ''}">Recipes</a>
        <a href="#/ingredients" data-route="ingredients" class="${location.hash === '#/ingredients' ? 'is-active' : ''}">Ingredients</a>
      </nav>
      <div class="topbar__actions">
        <button type="button" class="icon-btn" aria-label="Toggle theme" onClick=${toggleTheme}>
          ${themeIcon()}
        </button>
        <button type="button" class="icon-btn" aria-label="Sign out" onClick=${logout} title="Sign out">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        </button>
      </div>
    </header>
  `
}